import {Link} from "react-router-dom";
import Box from "@mui/material/Box";
import {SxProps} from "@mui/material";

import {BmPrimaryButton} from "~/components/buttons";
import {BmNewLogo} from "~/components/icons/otherIcons";
import {HOME_PATH} from "~/modules/routing";
import {designColors} from "~/ui";

import {styles} from "./Header.styles";

interface HeaderProps {
  buttonName?: string;
  onButtonClick?: VoidFunction;
  sx?: SxProps;
}
export const Header: React.FC<HeaderProps> = ({onButtonClick, buttonName, sx}) => {
  return (
    <Box className={styles.root} sx={sx}>
      <Link to={HOME_PATH}>
        <BmNewLogo id="desktop-header-logo-icon" color={designColors.white} />
      </Link>
      {buttonName && <BmPrimaryButton onClick={onButtonClick}>{buttonName}</BmPrimaryButton>}
    </Box>
  );
};
